document.addEventListener( 'DOMContentLoaded', () => {

	/**
	 * The function used to show and hide the sections of the first graphic.
	 * @param {Node} scrollPanel
	 * @param {Node} graphic
	 */
	function showGraphic( scrollPanel, graphic, offset = 0 ) {
		if ( scrollPanel.getBoundingClientRect().top < offset ) {
			graphic.classList.remove( 'o-0' );
			graphic.classList.add( 'o-100' );
		} else {
			graphic.classList.remove( 'o-100' );
			graphic.classList.add( 'o-0' );
		}
	}

	const isSciencePage = document.querySelector( '.page-template-template-4-1-the-science' );

	if ( isSciencePage ) {

		// The elements related to the protein graphic with connected nodes.
		const howItWorksGraphic = document.getElementById( 'how-it-works-graphic' );
		const centerGraphic = howItWorksGraphic.querySelector( '.center-graphic' );
		const bottomLeftGraphic = howItWorksGraphic.querySelector( '.bottom-left-graphic' );
		const bottomRightGraphic = howItWorksGraphic.querySelector( '.bottom-right-graphic' );
		const topLeftGraphic = howItWorksGraphic.querySelector( '.top-left-graphic' );

		// Grab all the scroll panels related to the first animation section.
		const scrollPanels = document.querySelectorAll( '[data-scroll-panel]' );

		if ( scrollPanels ) {

			document.addEventListener( 'scroll', () => {

				scrollPanels.forEach( ( scrollPanel, index ) => {

					/**
					 * Show each part of the graphic as it's scroll panel enters view.
					 */
					if ( index === 0 ) {
						showGraphic( scrollPanel, centerGraphic, 800 );
					}

					if ( index === 1 ) {
						showGraphic( scrollPanel, bottomLeftGraphic, 400 );
					}

					if ( index === 2 ) {
						showGraphic( scrollPanel, topLeftGraphic, 400 );
					}

					if ( index === 3 ) {
						showGraphic( scrollPanel, bottomRightGraphic, 400 );
					}

				} );

			} );

		}

		const checkToShow = debounce( () => {
			const currentSlideElement = document.querySelector( '[data-current-slide]' );
			const slidePosition = currentSlideElement.offsetLeft;
		}, 100 );

		const triggerPanels = document.querySelectorAll( '[data-trigger-panel]' );
		const graphics = document.querySelectorAll( '[data-scene-graphic]' );
		const graphicsArray = [];

		graphics.forEach( graphic => {
			graphicsArray.push( graphic.id );
		} );

		if ( triggerPanels && graphics ) {

			document.addEventListener( 'scroll', () => {

				triggerPanels.forEach( ( triggerPanel, index ) => {

					if ( triggerPanel.getBoundingClientRect().top <= 0 && triggerPanel.getBoundingClientRect().bottom >= 0 ) {

						graphicsArray.forEach( element => {
							const elementToHide = document.getElementById( element );
							if ( elementToHide && elementToHide.classList.contains( 'o-100' ) ) {
								elementToHide.classList.remove( 'o-100' );
								elementToHide.classList.add( 'o-0' );
								if ( elementToHide.id === 'rbc-bolt' ) {
									elementToHide.removeAttribute( 'data-flash' );
									elementToHide.removeAttribute( 'data-flash-2' );
								}
								if ( elementToHide.id === 'burst-rbc-graphic' ) {

									const cellBubbles = elementToHide.querySelectorAll( '[data-cell-bubble]' );

									cellBubbles.forEach( cellBubble => {
										cellBubble.removeAttribute( 'data-bubble-fade' );
									} );

								}
							}
						} );

						let elementsToShow = triggerPanel.getAttribute( 'data-show' );
						elementsToShow = elementsToShow.split( ' ' );
						elementsToShow.forEach( element => {
							const elementToShow = document.getElementById( element );
							if ( elementToShow.classList.contains( 'o-0' ) ) {
								elementToShow.classList.remove( 'o-0' );
								elementToShow.classList.add( 'o-100' );
								if ( elementToShow.id === 'spleen-graphic' ) {
									const bolt = document.getElementById( 'rbc-bolt' );
									bolt.setAttribute( 'data-flash', 'data-flash-2' );
								}
								if ( elementToShow.id === 'burst-rbc-graphic' ) {
									const cellBubbles = elementToShow.querySelectorAll( '[data-cell-bubble]' );
									let duration = 1500;
									let delay = 1500;

									cellBubbles.forEach( ( cellBubble, i ) => {

										cellBubble.setAttribute( 'data-bubble-fade', '1500' );

										if ( i === 0 ) {
											duration = '1500';
											delay = '500';
										}

										if ( i === 1 ) {
											duration = '1750';
											delay = '750';
										}

										if ( i === 2 ) {
											duration = '2000';
											delay = '1000';
										}

										if ( i === 3 ) {
											duration = '2500';
											delay = '1250';
										}

										if ( i === 4 ) {
											duration = '2500';
											delay = '1500';
										}

										if ( i === 5 ) {
											duration = '2500';
											delay = '1750';
										}

										if ( i === 6 ) {
											duration = '2500';
											delay = '2000';
										}

										cellBubble.style.animationDuration = `${duration}ms`;
										cellBubble.style.animationDelay = `${delay}ms`;

									} );
									// const bubble = document.getElementById( 'cell-bubble-1' );
									// bubble.setAttribute( 'data-bubble-fade', '1500' );
									// const bubble2 = document.getElementById( 'cell-bubble-2' );
									// bubble2.setAttribute( 'data-bubble-fade', '1750' );
								}
								if ( elementToShow.id === 'rbc-bolt' ) {
									elementToShow.setAttribute( 'data-flash', 'data-flash' );
								}
							}
						} );
					} else {
						// console.log( 'out' );
					}

				} );

			} );

		}

	}

} );
